<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate('', false)"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (onSelectAll)="onSelectAll($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (onRefresh)="onReset()"
>
  <div class="card-toolbar" after-btns>
    <!-- group edit btn -->
    <div [matTooltip]="'common.groupEdit' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupEdit()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-pencil-outline mdi-20px tw-p-0 text-warning"></i>
      </button>
    </div>

    <!-- groupDeletion btn -->
    <div [matTooltip]="'common.groupDeletion' | translate">
      <button
        [disabled]="selectedIds?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
    </div>
  </div>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-px-4 !tw-py-2">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- checkbox -->
        <td>
          <div class="form-check tw-text-center">
            <input
              type="checkbox"
              class="form-check-input tw-mt-[1px]"
              (click)="onAddSelectedContact($event, item, row, false)"
              [attr.data-checkbox-id]="item.id"
            />
          </div>
        </td>

        <!-- firstName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.firstName"></td-value>
        </td>

        <!-- lastName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.lastName"></td-value>
        </td>

        <!-- cellPhone -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.cellPhone"></td-value>
        </td>

        <!-- telephone -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.telephone"></td-value>
        </td>

        <!-- phonebookName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.phonebookName"></td-value>
        </td>

        <!-- gender -->
        <td>
          <span> {{ item?.gender | enumToText : GenderTypeEnumValues }}</span>
        </td>

        <!-- createType -->
        <td>
          <span>
            {{
              item?.createType | enumToText : ContactCreateTypeEnumValues
            }}</span
          >
        </td>

        <!-- phonebookTypes -->
        <td>
          <span>
            {{
              item?.phonebookTypes | enumToText : PhonebookTypeEnumValues
            }}</span
          >
        </td>

        <!-- created -->
        <td class="tw-py-2">
          <td-value type="dateTime" [value]="item?.createdAt"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete($event.id, item?.phonebookId, $event.name)"
            (onUpdate)="
              onAddSelectedContact($event, item, row, true); onUpdate(item?.id)
            "
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-contacts-by-cellphone-form
    [formPageConfig]="formPageConfig"
    [selectedContacts]="selectedContacts"
    [mobileNumber]="mobileNumber"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-contacts-by-cellphone-form>
</ng-container>
